"use client";
import { useEffect, useState } from "react";
import { ReserveEditModal } from "./ReserveEditModal";
import { ISchedule } from "@gettactic/api";

type Props = {
  editModal: boolean;
  schedule: ISchedule;
  canRespondCancel?: boolean;
  toggleModal: () => void;
  respondCancel: () => void;
};

export function SafeReserveEditModal({
  editModal,
  toggleModal,
  schedule,
  canRespondCancel,
  respondCancel
}: Props) {
  const [allowClosing, setAllowClosing] = useState(false);

  // Reset the allowClosing state whenever the modal props change
  useEffect(() => {
    setAllowClosing(false);
    const timer = setTimeout(() => {
      setAllowClosing(true);
    }, 500);
    return () => clearTimeout(timer);
  }, [editModal, schedule]);

  // Only allow toggleModal to close the modal if allowClosing is true
  const safeToggleModal = () => {
    if (allowClosing) {
      toggleModal();
    }
  };

  return (
    <ReserveEditModal
      editModal={editModal}
      toggleModal={safeToggleModal}
      schedule={schedule}
      canRespondCancel={canRespondCancel}
      respondCancel={respondCancel}
    />
  );
}
